import styled from 'styled-components';

/**
 * The design's `.upload-sq`.
 *
 * `form/imageUploader` was missed by the control pass in the same way
 * `form/passwordInput` was: it was still a 76px circle on `#eef1f6` with a
 * `#dfe0eb` border, neither of them a token, and it is the only uploader in
 * the product.
 *
 * A square rather than a circle, and dashed rather than solid, because it is
 * a drop target for a photograph — the same reasoning that separates
 * `components/avatar` from `components/thumb`: a circle is a person.
 */
export const Uploader = styled.label`
  display: grid;
  place-items: center;
  width: 72px;
  height: 72px;
  overflow: hidden;
  border: 1.5px dashed var(--line-strong);
  border-radius: var(--r-md);
  background: var(--surface-alt);
  color: var(--text-faint);
  cursor: pointer;
  transition:
    border-color 0.12s,
    background-color 0.12s,
    color 0.12s;

  &:hover {
    border-color: var(--primary);
    background: var(--primary-soft);
    color: var(--primary);
  }

  /* Holding a picture, it stops being a drop target and becomes the picture. */
  &.filled {
    border-style: solid;
    border-color: var(--line);
    background: var(--surface);
  }

  svg {
    width: 20px;
    height: 20px;
    stroke-width: 1.6;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
